// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bill-overseas-s-center-view .totalLabel {\n  margin-top: 6px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
